// Read before Vue modules initialize; the server renders this in the document head.
const element = typeof document !== "undefined"
    ? document.getElementById("suf-frontend-config")
    : null;

export default element ? JSON.parse(element.textContent) : {};
